export class UnProcessableEntity extends Error {
  data?: any;

  constructor(data?: any) {
    super('unable to process present instructions');
    this.name = 'unable to process present instructions';
    this.data = data;
  }
}
